// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const RivePlayerContract = contract({
  name: "RivePlayer",
  description: "Rive runtime wrapped in the shared media surface. Reach for Rive when you need interactive state-machine animations driven by scroll/hover/input. For non-interactive looping video, use VideoPlayer; for shader-driven backgrounds, use ThreeScene.",
  import: "@gradeui/ui",
  aliases: ["rive","riv","animation","animated","lottie"],
  composesWith: ["MediaSurface (internal)","Card","any container"],
  styleDefaults: {"RiveInner":"absolute inset-0 flex items-end justify-end p-2"},
  props: {
  "src": {
      schema: z.string(),
      design: "content",
      description: "URL or path to the .riv file",
  },
  "stateMachines": {
      schema: z.union([z.string(), z.array(z.string())]).optional(),
      design: "knob",
      description: "state machine(s) to run",
  },
  "artboard": {
      schema: z.string().optional(),
      design: "content",
      description: "artboard name; omit to use default",
  },
  "controls": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "viewer mode by default; set true for play/pause overlay",
      default: false,
  },
  "autoPlay": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "respects reduced-motion",
      default: true,
  },
  "loop": {
      schema: z.boolean().optional(),
      design: "knob",
      default: true,
  },
  "pauseOffscreen": {
      schema: z.boolean().optional(),
      design: "knob",
      default: true,
  },
  "fit": {
      schema: z.enum(["contain", "cover", "fill", "fitWidth", "fitHeight", "none"]).optional(),
      design: "knob",
      default: "contain",
  },
  "stateMachineInputs": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "aspect": {
      schema: z.enum(["video", "square", "portrait", "wide", "auto"]).optional(),
      design: "knob",
      default: "square",
  },
  "radius": {
      schema: z.enum(["none", "sm", "md", "lg", "xl"]).optional(),
      design: "knob",
      default: "lg",
  },
  "poster": {
      schema: z.string().optional(),
      design: "content",
      description: "image shown while the runtime loads",
  },
  },
});
